// Objets à usage unique (consumables) — droppent dans les coffres + shop.
// Certains sont utilisables n'importe quand (effet immédiat), d'autres seulement en combat.

export const ITEMS = {
  health_potion: {
    id: "health_potion",
    nom: "Potion de Vie",
    description: "Restaure 50% de tes PV max.",
    icon: "🧪",
    color: "bg-rose-500",
    rarity: "common",
    inCombat: true,
    everywhere: true,
    effect: { type: "heal_percent", value: 0.5 },
  },
  mega_potion: {
    id: "mega_potion",
    nom: "Méga Potion",
    description: "Restaure 100% de tes PV max.",
    icon: "💉",
    color: "bg-rose-600",
    rarity: "uncommon",
    inCombat: true,
    everywhere: true,
    effect: { type: "heal_percent", value: 1.0 },
  },
  bomb: {
    id: "bomb",
    nom: "Bombe",
    description: "Inflige des dégâts directs à l'ennemi, qui augmentent avec l'étage de la run (combat uniquement).",
    icon: "💣",
    color: "bg-orange-500",
    rarity: "uncommon",
    inCombat: true,
    everywhere: false,
    effect: { type: "direct_damage", value: 40 },
  },
  strength_elixir: {
    id: "strength_elixir",
    nom: "Élixir de Force",
    description: "+3 ATK pour le reste de la run.",
    icon: "💪",
    color: "bg-amber-600",
    rarity: "rare",
    inCombat: true,
    everywhere: true,
    effect: { type: "permanent_stat", stat: "atk", value: 3 },
  },
  iron_skin: {
    id: "iron_skin",
    nom: "Peau d'Acier",
    description: "+3 DEF pour le reste de la run.",
    icon: "🪨",
    color: "bg-slate-500",
    rarity: "rare",
    inCombat: true,
    everywhere: true,
    effect: { type: "permanent_stat", stat: "def", value: 3 },
  },
  ancient_scroll: {
    id: "ancient_scroll",
    nom: "Parchemin Ancien",
    description: "Gagne 100 XP de run instantanément.",
    icon: "📜",
    color: "bg-amber-500",
    rarity: "rare",
    inCombat: false,
    everywhere: true,
    effect: { type: "run_xp", value: 100 },
  },
  lucky_charm: {
    id: "lucky_charm",
    nom: "Charme Chanceux",
    description: "+10% CRIT pour le reste de la run.",
    icon: "🍀",
    color: "bg-emerald-500",
    rarity: "rare",
    inCombat: true,
    everywhere: true,
    effect: { type: "permanent_stat", stat: "crit", value: 10 },
  },
  smoke_bomb: {
    id: "smoke_bomb",
    nom: "Bombe Fumigène",
    description: "Permet de fuir le combat sans pénalité.",
    icon: "💨",
    color: "bg-slate-400",
    rarity: "uncommon",
    inCombat: true,
    everywhere: false,
    effect: { type: "flee_combat" },
  },
  golden_apple: {
    id: "golden_apple",
    nom: "Pomme d'Or",
    description: "+10 PV max permanents.",
    icon: "🍎",
    color: "bg-yellow-500",
    rarity: "rare",
    inCombat: true,
    everywhere: true,
    effect: { type: "permanent_stat", stat: "pv", value: 10 },
  },
  // === Reliques permanentes (rares à très rares) ===
  ring_of_might: {
    id: "ring_of_might",
    nom: "Anneau de Puissance",
    description: "Relique : +5 ATK et +5 DEF permanents.",
    icon: "💍",
    color: "bg-amber-500",
    rarity: "rare",
    inCombat: true,
    everywhere: true,
    effect: { type: "multi_stat", stats: { atk: 5, def: 5 } },
  },
  amulet_of_swiftness: {
    id: "amulet_of_swiftness",
    nom: "Amulette de Vélocité",
    description: "Relique : +8 VIT et +5% précision permanents.",
    icon: "📿",
    color: "bg-emerald-500",
    rarity: "rare",
    inCombat: true,
    everywhere: true,
    effect: { type: "multi_stat", stats: { vit: 8, precision: 5 } },
  },
  crown_of_kings: {
    id: "crown_of_kings",
    nom: "Couronne des Rois",
    description: "Relique légendaire : +10 à TOUTES les stats flat.",
    icon: "👑",
    color: "bg-yellow-400",
    rarity: "rare",
    inCombat: true,
    everywhere: true,
    effect: { type: "all_flat_stats", value: 10 },
  },
  phoenix_feather: {
    id: "phoenix_feather",
    nom: "Plume de Phénix",
    description: "Te ressuscite à 50% PV la prochaine fois que tu meurs dans cette run.",
    icon: "🪶",
    color: "bg-orange-500",
    rarity: "rare",
    inCombat: true,
    everywhere: true,
    effect: { type: "revive_token" },
  },
  void_essence: {
    id: "void_essence",
    nom: "Essence du Néant",
    description: "Relique : +8 Dégâts Élémentaires et +5% Crit permanents.",
    icon: "🌌",
    color: "bg-purple-600",
    rarity: "rare",
    inCombat: true,
    everywhere: true,
    effect: { type: "multi_stat", stats: { degatsElem: 8, crit: 5 } },
  },
  dragon_scale: {
    id: "dragon_scale",
    nom: "Écaille de Dragon",
    description: "Relique : +10 RÉS et +15 PV max permanents.",
    icon: "🐉",
    color: "bg-rose-700",
    rarity: "rare",
    inCombat: true,
    everywhere: true,
    effect: { type: "multi_stat", stats: { res: 10, pv: 15 } },
  },
  cursed_skull: {
    id: "cursed_skull",
    nom: "Crâne Maudit",
    description: "Risque : -10 PV max mais +12 ATK permanents.",
    icon: "💀",
    color: "bg-slate-700",
    rarity: "uncommon",
    inCombat: true,
    everywhere: true,
    effect: { type: "multi_stat", stats: { atk: 12, pv: -10 } },
  },
  speed_boots: {
    id: "speed_boots",
    nom: "Bottes Rapides",
    description: "+6 VIT permanents.",
    icon: "🥾",
    color: "bg-amber-700",
    rarity: "uncommon",
    inCombat: true,
    everywhere: true,
    effect: { type: "permanent_stat", stat: "vit", value: 6 },
  },
  rune_of_protection: {
    id: "rune_of_protection",
    nom: "Rune de Protection",
    description: "+8% RÉS permanents.",
    icon: "🔯",
    color: "bg-indigo-500",
    rarity: "uncommon",
    inCombat: true,
    everywhere: true,
    effect: { type: "permanent_stat", stat: "res", value: 8 },
  },
  mana_crystal: {
    id: "mana_crystal",
    nom: "Cristal de Mana",
    description: "Restaure ton énergie au maximum (utilisable en combat).",
    icon: "💎",
    color: "bg-cyan-500",
    rarity: "uncommon",
    inCombat: true,
    everywhere: false,
    effect: { type: "refill_energy" },
  },
  // === Objets de scaling (% des stats actuelles, calculé à l'utilisation) ===
  colossus_heart: {
    id: "colossus_heart",
    nom: "Cœur du Colosse",
    description: "Relique : +10% à TOUTES tes stats (calculé à l'utilisation).",
    icon: "🌟",
    color: "bg-amber-400",
    rarity: "rare",
    inCombat: true,
    everywhere: true,
    effect: { type: "percent_all_stats", value: 0.10 },
  },
  prismatic_core: {
    id: "prismatic_core",
    nom: "Noyau Prismatique",
    description: "Relique légendaire : +15% à TOUTES tes stats (calculé à l'utilisation).",
    icon: "🔮",
    color: "bg-fuchsia-500",
    rarity: "rare",
    inCombat: true,
    everywhere: true,
    effect: { type: "percent_all_stats", value: 0.15 },
  },
  titan_blood: {
    id: "titan_blood",
    nom: "Sang de Titan",
    description: "+20% ATK (calculé à l'utilisation).",
    icon: "🩸",
    color: "bg-red-600",
    rarity: "uncommon",
    inCombat: true,
    everywhere: true,
    effect: { type: "percent_stat", stat: "atk", value: 0.20 },
  },
  vital_bloom: {
    id: "vital_bloom",
    nom: "Floraison Vitale",
    description: "+20% PV max (calculé à l'utilisation).",
    icon: "🌺",
    color: "bg-pink-500",
    rarity: "uncommon",
    inCombat: true,
    everywhere: true,
    effect: { type: "percent_stat", stat: "pv", value: 0.20 },
  },
};

export const ITEM_RARITY_COLORS = {
  common: "border-slate-400",
  uncommon: "border-emerald-400",
  rare: "border-fuchsia-400",
};

// Tirage aléatoire pour drop de coffre selon rareté du coffre
export const rollItemFromChest = (chestRarity) => {
  const pool = Object.values(ITEMS);
  const weights = {
    commun: { common: 70, uncommon: 25, rare: 5 },
    rare: { common: 50, uncommon: 35, rare: 15 },
    epique: { common: 30, uncommon: 40, rare: 30 },
    legendaire: { common: 15, uncommon: 35, rare: 50 },
    prismatique: { common: 5, uncommon: 25, rare: 70 },
  };
  const w = weights[chestRarity] || weights.commun;
  const roll = Math.random() * 100;
  let targetRarity = "common";
  if (roll < w.rare) targetRarity = "rare";
  else if (roll < w.rare + w.uncommon) targetRarity = "uncommon";
  const filtered = pool.filter((i) => i.rarity === targetRarity);
  return filtered[Math.floor(Math.random() * filtered.length)];
};
